export default "__VITE_ASSET__57982c8c__"